module.exports = __webpack_public_path__ + "static/media/Tile Image - HV 7054 (1).b3bd4f40.png";